import type { SystemUsage } from '@racepointenergy/swc/scs/types/host'

import formatBytes from 'app/utils/formatBytes'

import {
  ProcessesStatsContainer,
  ProcessesStatsList,
  ProcessesStatsTitle,
} from './styles'
import { FormattedMessage } from 'react-intl'
import { processMessages } from './messages'
import ProcessesStatsItem from './ProcessesStatsItem'

interface ProcessesStatsProps {
  stats: SystemUsage | undefined
}

function ProcessesStats({ stats }: ProcessesStatsProps) {
  const freeMem = formatBytes(stats?.FreeMemory)
  const wiredMem = formatBytes(stats?.WiredMemory)
  const activeMem = formatBytes(stats?.ActiveMemory)
  const inactiveMem = formatBytes(stats?.InactiveMemory)
  const totalMem = formatBytes(stats?.TotalPhysicalMemory)

  return (
    <ProcessesStatsContainer>
      <ProcessesStatsTitle>
        <FormattedMessage {...processMessages.sysStats} />
      </ProcessesStatsTitle>
      <ProcessesStatsList>
        {stats?.CPUType && (
          <ProcessesStatsItem title="CPU Type" value={stats.CPUType} />
        )}
        {stats?.CPULoad && (
          <ProcessesStatsItem title="CPU Load Avg" value={stats.CPULoad} />
        )}

        <ProcessesStatsItem title="Free Memory" value={freeMem} />
        <ProcessesStatsItem title="Wired Memory" value={wiredMem} />
        <ProcessesStatsItem title="Active Memory" value={activeMem} />
        <ProcessesStatsItem title="Inactive Memory" value={inactiveMem} />
        <ProcessesStatsItem title="Total Memory" value={totalMem} />
      </ProcessesStatsList>
    </ProcessesStatsContainer>
  )
}

export default ProcessesStats
